const RecaptchaBadgeStyle = `
  .grecaptcha-badge {
    visibility: hidden !important;
  }
`;

export default RecaptchaBadgeStyle;
